var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-scale-transition',{attrs:{"origin":"center center 0"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.showScrollToTop),expression:"showScrollToTop"}],staticClass:"scroll-to-top",attrs:{"fab":"","dark":"","color":"primary"},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }